import { render, staticRenderFns } from "./calc-textarea.vue?vue&type=template&id=512b01c8&"
import script from "./calc-textarea.vue?vue&type=script&lang=js&"
export * from "./calc-textarea.vue?vue&type=script&lang=js&"
import style0 from "./calc-textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports